import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCore, ProductType } from "@obg/core.config";
import { ConfigService, fromMinutesToMilliseconds } from "@obg/ngx.global";
import { Observable } from "rxjs";

import { REALITY_CHECK_ACTIVE_PRODUCT_MAP } from "../responsible-gaming.const";

@Injectable({
	providedIn: "root",
})
export class RealityCheckConfigService {
	constructor(private configService: ConfigService<ObgConfigFeAdaptiveClientCore>) {}

	/**
	 * This config is under jurisdiction
	 */
	getIsRealityCheckEnabled(): boolean {
		return this.configService.get((x) => x.core.realityCheck.isEnabled, true);
	}

	getIsRealityCheckEnabled$(): Observable<boolean> {
		return this.configService.get$((x) => x.core.realityCheck.isEnabled ?? true, true);
	}

	/**
	 * This config is under jurisdiction
	 */
	getRealityCheckIntervalMillis(): number {
		return this.configService.get((x) => x.core.realityCheck.interval, fromMinutesToMilliseconds(60));
	}

	/**
	 * This config is under jurisdiction
	 */
	getRealityCheckFirstPulseTimeMillis(): number {
		return this.configService.get((x) => x.core.realityCheck.firstPulseTime, this.getRealityCheckIntervalMillis());
	}

	/**
	 * This config is under jurisdiction
	 */
	getRealityCheckActiveProductMap(): Partial<Record<ProductType, boolean>> {
		return this.configService.get((x) => x.core.realityCheck.activeProductMap, REALITY_CHECK_ACTIVE_PRODUCT_MAP);
	}

	/**
	 * This config is under jurisdiction
	 */
	isRealityCheckTimerStartedFromLogin(): boolean {
		return this.configService.get((x) => x.core.realityCheck.isTimerStartedFromLogin, false);
	}

	/**
	 * This config is under jurisdiction
	 */
	isRealityCheckTickingRegardlessOfProduct(): boolean {
		return this.configService.get((x) => x.core.realityCheck.isRealityCheckTickingRegardlessOfProduct, false);
	}

	/**
	 * This config is under jurisdiction
	 */
	isRealityCheckBetWinSummaryNeeded(): boolean {
		return this.configService.get((x) => x.core.realityCheck.isRealityCheckBetWinSummaryNeeded, true);
	}
}
